module.exports = __webpack_public_path__ + "fonts/CashSans-Bold.78961ec.woff2";